/**
 * Para onde ir depois de entrar ou criar conta.
 *
 * A porta Dozy Empresas precisa de continuar no registo da empresa
 * (/empresa/nova). O valor vem da barra de endereço, por isso só se aceita
 * esse caminho, e a finalidade só se for CONTRATAR ou PRESTAR. Qualquer
 * outro valor seria um redireccionamento aberto.
 */

const FINALIDADES = new Set(['CONTRATAR', 'PRESTAR']);

export function finalidadePermitida(valor) {
  return FINALIDADES.has(valor) ? valor : null;
}

export function destinoAposAuth(search = '') {
  const bruto = String(search || '');
  const params = new URLSearchParams(bruto.startsWith('?') ? bruto.slice(1) : bruto);
  const valor = params.get('destino');
  if (!valor) return null;

  let url;
  try {
    url = new URL(valor, 'https://dozy.local');
  } catch {
    return null;
  }
  if (url.origin !== 'https://dozy.local' || url.pathname !== '/empresa/nova') return null;

  const chaves = [...url.searchParams.keys()];
  if (chaves.some((chave) => chave !== 'finalidade')) return null;

  const naBarra = params.get('finalidade');
  const noDestino = url.searchParams.get('finalidade');
  if (naBarra != null && !finalidadePermitida(naBarra)) return null;
  if (noDestino != null && !finalidadePermitida(noDestino)) return null;
  if (naBarra && noDestino && naBarra !== noDestino) return null;

  const finalidade = finalidadePermitida(naBarra) || finalidadePermitida(noDestino);
  return finalidade ? `/empresa/nova?finalidade=${finalidade}` : '/empresa/nova';
}

export function comDestino(caminho, destino) {
  if (!destino || destinoAposAuth(`?destino=${encodeURIComponent(destino)}`) !== destino) {
    return caminho;
  }
  const [path, query = ''] = String(caminho).split('?');
  const params = new URLSearchParams(query);
  params.set('destino', destino);
  const serializado = params.toString();
  return serializado ? `${path}?${serializado}` : path;
}

/**
 * `incluirProfissional` só no início de sessão. No registo, um profissional
 * novo tem de passar pela verificação — saltá-la por causa do destino
 * deixava a conta a meio.
 */
export function caminhoDepoisDeAuth({ role, search, porOmissao, incluirProfissional = false }) {
  const destino = destinoAposAuth(search);
  if (destino && (incluirProfissional || role !== 'worker')) return destino;
  return porOmissao;
}
